import Icon from '../Icon'
import { FieldCheckboxIndicator, FieldCheckboxLabel, FieldCheckboxWrapper } from './FieldCheckbox.styles'

const FieldCheckbox = ({ checked, label, size = 'default' }) => {
  return (
    <FieldCheckboxWrapper>
      <FieldCheckboxIndicator checked={checked} size={size}>
        <Icon name="tick" size={size === 'default' ? 12 : 9} />
      </FieldCheckboxIndicator>
      {label && <FieldCheckboxLabel>{label}</FieldCheckboxLabel>}
    </FieldCheckboxWrapper>
  )
}

export default FieldCheckbox
